import { ToastProvider } from "@stagvista/ui";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";

import { CloudSessionProvider } from "./hooks/use-cloud-session.js";
import { routeTree } from "./routeTree.gen";
import "./styles/globals.css";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ToastProvider>
      <CloudSessionProvider>
        <RouterProvider router={router} />
      </CloudSessionProvider>
    </ToastProvider>
  </React.StrictMode>,
);
